// src/pages/solicitacoes/Solicitacoes.js

import React, { useState } from 'react';
import { createSolicitacao } from '../../services/api';
import { maskPhone } from '../../utils/helpers';
import FileUpload from '../../components/forms/FileUpload';
import Toast from '../../components/common/Toast';
import { uploadArquivo } from '../../services/uploadHelper';

const TIPOS = [
  { value: 'batisterio', label: 'Batistério', icon: '📜', desc: 'Finalidade: Casamento, emissão de documento ou ordem sacerdotal' },
  { value: 'declaracao', label: 'Declaração de Batismo',  icon: '📋', desc: 'Finalidade: Padrinho/madrinha, Primeira Eucaristia, Crisma ou MESC' },
  { value: 'declaracao_casamento', label: 'Declaração de Casamento', icon: '💒', desc: 'Comprovante do Sacramento do Matrimônio' },
];

const FINALIDADES_BATISTERIO = [
  'Casamento',
  'Emissão de documento',
  'Ordem',
  'Outra',
];

const FINALIDADES_DECLARACAO = [
  'Ser padrinho ou madrinha',
  'Primeira Eucaristia',
  'Crisma',
  'MESC',
  'Outra',
];

const initialForm = {
  tipo: '',
  // Batistério e Declaração
  nome: '',
  telefone: '',
  finalidade: '',
  localBatismo: '',
  anoBatismo: '',
  // Declaração de Casamento
  nomeNoivo: '',
  nomeNoiva: '',
  dataCasamento: '',
  localCasamento: '',
  telefoneCasamento: '',
};

const Solicitacoes = () => {
  const [form, setForm] = useState(initialForm);
  const [errors, setErrors] = useState({});
  const [docFile, setDocFile] = useState(null);
  const [toast, setToast] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    let v = value;
    if (name === 'telefone' || name === 'telefoneCasamento') v = maskPhone(value);
    setForm(f => ({ ...f, [name]: v }));
    setErrors(err => ({ ...err, [name]: '' }));
  };

  const setTipo = (tipo) => {
    setForm({ ...initialForm, tipo });
    setErrors({});
    setDocFile(null);
  };

  const isBatisterio = form.tipo === 'batisterio';
  const isDeclaracao = form.tipo === 'declaracao';
  const isCasamento = form.tipo === 'declaracao_casamento';

  const validate = () => {
    const errs = {};
    if (!form.tipo) { errs.tipo = 'Selecione o tipo de solicitação.'; return errs; }

    if (isBatisterio || isDeclaracao) {
      if (!form.nome.trim())      errs.nome      = 'Nome obrigatório.';
      if (!form.telefone.trim())  errs.telefone  = 'Telefone obrigatório.';
      if (!form.finalidade)       errs.finalidade = 'Selecione a finalidade.';
      if (!docFile)               errs.documento  = 'Documento obrigatório.';
    }

    if (isCasamento) {
      if (!form.nomeNoivo.trim())       errs.nomeNoivo       = 'Nome do noivo obrigatório.';
      if (!form.nomeNoiva.trim())       errs.nomeNoiva       = 'Nome da noiva obrigatório.';
      if (!form.telefoneCasamento.trim()) errs.telefoneCasamento = 'Telefone obrigatório.';
      if (!form.dataCasamento)          errs.dataCasamento   = 'Data obrigatória.';
      if (!form.localCasamento.trim())  errs.localCasamento  = 'Local obrigatório.';
    }

    return errs;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length > 0) {
      setErrors(errs);
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    setLoading(true);
    try {
      // Upload direto para o Hostgator (só se tiver documento)
      let urlDocumento = '';
      if (docFile) {
        urlDocumento = await uploadArquivo(docFile, 'solicitacoes');
      }

      // Envia só a URL para o GAS via GET
      const dados = {
        ...form,
        urlDocumento,
      };

      const res = await createSolicitacao(dados);
      if (res?.success) {
        setSubmitted(true);
        setForm(initialForm);
        setDocFile(null);
      } else {
        setToast({ msg: res?.message || 'Erro ao enviar solicitação.', type: 'error' });
      }
    } catch {
      setToast({ msg: 'Erro de conexão. Tente novamente.', type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <main style={{ paddingTop: '72px' }}>
        <section style={{ minHeight: '70vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 'var(--space-3xl) var(--space-xl)' }}>
          <div style={{ textAlign: 'center', maxWidth: 520 }}>
            <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>✅</div>
            <h2 style={{ marginBottom: '1rem' }}>Solicitação Enviada!</h2>
            <p style={{ marginBottom: '0.75rem' }}>
              Sua solicitação foi registrada com sucesso!
            </p>
            <p style={{ marginBottom: '2rem', fontSize: '0.95rem', color: 'var(--gray-600)' }}>
              O prazo médio de emissão é de <strong>3 dias úteis</strong>. Quando o documento estiver pronto,
              entraremos em contato pelo telefone informado.
            </p>
            <button className="btn btn-primary btn-lg" onClick={() => setSubmitted(false)}>
              Nova Solicitação
            </button>
          </div>
        </section>
      </main>
    );
  }

  return (
    <main style={{ paddingTop: '72px' }}>
      {toast && <Toast message={toast.msg} type={toast.type} onClose={() => setToast(null)} />}

      {/* Hero */}
      <section style={{
        background: 'linear-gradient(135deg, var(--navy-dark) 0%, var(--navy) 100%)',
        padding: 'var(--space-2xl) var(--space-xl)',
        textAlign: 'center', position: 'relative', overflow: 'hidden',
      }}>
        <div style={{ position: 'absolute', inset: 0, backgroundImage: 'radial-gradient(circle, rgba(201,160,48,0.07) 1px, transparent 1px)', backgroundSize: '40px 40px', pointerEvents: 'none' }} />
        <div style={{ position: 'relative' }}>
          <div className="ornament" style={{ justifyContent: 'center', marginBottom: '0.75rem' }}>Secretaria</div>
          <div style={{ fontSize: '2.5rem', marginBottom: '0.5rem' }}>📜</div>
          <h1 style={{ color: 'var(--white)', marginBottom: '0.5rem' }}>Solicitações</h1>
          <p style={{ color: 'rgba(255,255,255,0.7)', maxWidth: 520, margin: '0 auto', lineHeight: 1.8 }}>
            Solicite seu Batistério, Declaração ou Declaração de Casamento de forma rápida e simples.
          </p>
        </div>
      </section>

      {/* Formulário */}
      <section style={{ background: 'var(--off-white)', padding: 'var(--space-xl) var(--space-xl)' }}>
        <div className="container" style={{ maxWidth: 800 }}>

          {/* Seleção do tipo */}
          <div style={{ marginBottom: 'var(--space-xl)' }}>
            <h2 className="section-title" style={{ marginBottom: '1.5rem' }}>O que você precisa?</h2>
            {errors.tipo && <p className="form-error" style={{ textAlign: 'center', marginBottom: '0.75rem' }}>{errors.tipo}</p>}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 'var(--space-md)' }}>
              {TIPOS.map(({ value, label, icon, desc }) => (
                <button key={value} type="button" onClick={() => setTipo(value)} style={{
                  padding: 'var(--space-lg)',
                  borderRadius: 'var(--radius-lg)',
                  border: `2px solid ${form.tipo === value ? 'var(--gold)' : 'var(--gray-200)'}`,
                  background: form.tipo === value ? 'var(--gold-pale)' : 'var(--white)',
                  cursor: 'pointer', textAlign: 'center',
                  transition: 'all 0.15s',
                  boxShadow: form.tipo === value ? 'var(--shadow-gold)' : 'var(--shadow-sm)',
                }}>
                  <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>{icon}</div>
                  <p style={{ fontWeight: 600, color: 'var(--navy)', fontSize: '0.95rem', marginBottom: '0.35rem' }}>{label}</p>
                  <p style={{ fontSize: '0.78rem', color: 'var(--gray-400)', lineHeight: 1.5 }}>{desc}</p>
                </button>
              ))}
            </div>
          </div>

          {/* Formulário condicional */}
          {form.tipo && (
            <div className="form-card-mobile" style={{ background: 'var(--white)', borderRadius: 'var(--radius-xl)', boxShadow: 'var(--shadow-md)', padding: 'var(--space-2xl)' }}>

              {/* ── BATISTÉRIO ou DECLARAÇÃO ── */}
              {(isBatisterio || isDeclaracao) && (
                <form onSubmit={handleSubmit} noValidate>
                  <h3 style={{ marginBottom: '0.25rem' }}>
                    {isBatisterio ? '📜 Batistério' : '📋 Declaração'}
                  </h3>
                  <p style={{ color: 'var(--gray-400)', fontSize: '0.875rem', marginBottom: isBatisterio ? 'var(--space-md)' : 'var(--space-lg)' }}>
                    {isBatisterio
                      ? 'Para casamento, emissão de documento ou ordem sacerdotal.'
                      : 'Para ser padrinho/madrinha, Primeira Eucaristia, Crisma ou MESC.'}
                  </p>

                  {isBatisterio && (
                    <div style={{ background: 'var(--gold-pale)', borderLeft: '4px solid var(--gold)', borderRadius: 'var(--radius-md)', padding: 'var(--space-md)', marginBottom: 'var(--space-lg)', display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                      <span style={{ fontSize: '1.25rem' }}>💰</span>
                      <p style={{ margin: 0, fontSize: '0.9rem', color: 'var(--navy)' }}>
                        Taxa de emissão do Batistério: <strong>R$ 45,00</strong> — paga presencialmente na secretaria da paróquia ao retirar o documento.
                      </p>
                    </div>
                  )}

                  {/* Nome + Telefone + Finalidade em grid */}
                  <h4 style={{ color: 'var(--navy)', marginBottom: 'var(--space-md)', paddingBottom: '0.5rem', borderBottom: '2px solid var(--gold-pale)' }}>Dados do Solicitante</h4>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 'var(--space-md)', marginBottom: 'var(--space-lg)' }}>
                    <div className="form-group" style={{ margin: 0 }}>
                      <label className="form-label">Nome Completo <span className="required">*</span></label>
                      <input name="nome" value={form.nome} onChange={handleChange}
                        className={`form-input${errors.nome ? ' error' : ''}`} />
                      {errors.nome && <p className="form-error">{errors.nome}</p>}
                    </div>
                    <div className="form-group" style={{ margin: 0 }}>
                      <label className="form-label">Telefone / WhatsApp <span className="required">*</span></label>
                      <input name="telefone" value={form.telefone} onChange={handleChange}
                        placeholder="(85) 99000-0000"
                        className={`form-input${errors.telefone ? ' error' : ''}`} />
                      {errors.telefone && <p className="form-error">{errors.telefone}</p>}
                    </div>
                    <div className="form-group" style={{ margin: 0 }}>
                      <label className="form-label">Finalidade <span className="required">*</span></label>
                      <select name="finalidade" value={form.finalidade} onChange={handleChange}
                        className={`form-select${errors.finalidade ? ' error' : ''}`}>
                        <option value="">Selecione...</option>
                        {(isBatisterio ? FINALIDADES_BATISTERIO : FINALIDADES_DECLARACAO).map(f => (
                          <option key={f} value={f}>{f}</option>
                        ))}
                      </select>
                      {errors.finalidade && <p className="form-error">{errors.finalidade}</p>}
                    </div>
                  </div>

                  {/* Local e ano do batismo */}
                  <h4 style={{ color: 'var(--navy)', marginBottom: 'var(--space-md)', paddingBottom: '0.5rem', borderBottom: '2px solid var(--gold-pale)' }}>
                    Informações do Batismo <span style={{ color: 'var(--gray-400)', fontWeight: 400, fontSize: '0.85rem' }}>(opcional)</span>
                  </h4>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 'var(--space-md)', marginBottom: 'var(--space-lg)' }}>
                    <div className="form-group" style={{ margin: 0 }}>
                      <label className="form-label">Local do Batismo</label>
                      <input name="localBatismo" value={form.localBatismo} onChange={handleChange}
                        placeholder="Ex: Paróquia N. Sra. da Conceição"
                        className="form-input" />
                    </div>
                    <div className="form-group" style={{ margin: 0 }}>
                      <label className="form-label">Ano do Batismo</label>
                      <input name="anoBatismo" value={form.anoBatismo} onChange={handleChange}
                        placeholder="Ex: 1995" type="number" min="1900" max={new Date().getFullYear()}
                        className="form-input" />
                    </div>
                  </div>

                  {/* Documento */}
                  <h4 style={{ color: 'var(--navy)', marginBottom: 'var(--space-md)', paddingBottom: '0.5rem', borderBottom: '2px solid var(--gold-pale)' }}>Documento de Identificação</h4>
                  <FileUpload
                    label="RG, CNH ou outro documento oficial"
                    required
                    accept=".pdf,.jpg,.jpeg,.png"
                    hint="Frente e verso, se possível. Formatos: PDF, JPG, PNG."
                    error={errors.documento}
                    onChange={setDocFile}
                  />

                  <div className="submit-row" style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: 'var(--space-lg)', borderTop: '1px solid var(--gray-200)', marginTop: 'var(--space-lg)' }}>
                    <button type="submit" className="btn btn-primary btn-lg" disabled={loading}>
                      {loading ? 'Enviando...' : '📜 Enviar Solicitação'}
                    </button>
                  </div>
                </form>
              )}

              {/* ── DECLARAÇÃO DE CASAMENTO ── */}
              {isCasamento && (
                <form onSubmit={handleSubmit} noValidate>
                  <h3 style={{ marginBottom: '0.25rem' }}>💒 Declaração de Casamento</h3>
                  <p style={{ color: 'var(--gray-400)', fontSize: '0.875rem', marginBottom: 'var(--space-lg)' }}>
                    Declaração referente ao Sacramento do Matrimônio celebrado na paróquia.
                  </p>

                  {/* Dados do casal */}
                  <h4 style={{ color: 'var(--navy)', marginBottom: 'var(--space-md)', paddingBottom: '0.5rem', borderBottom: '2px solid var(--gold-pale)' }}>Dados do Casal</h4>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 'var(--space-md)', marginBottom: 'var(--space-md)' }}>
                    <div className="form-group" style={{ margin: 0 }}>
                      <label className="form-label">Nome do Noivo <span className="required">*</span></label>
                      <input name="nomeNoivo" value={form.nomeNoivo} onChange={handleChange}
                        className={`form-input${errors.nomeNoivo ? ' error' : ''}`} />
                      {errors.nomeNoivo && <p className="form-error">{errors.nomeNoivo}</p>}
                    </div>
                    <div className="form-group" style={{ margin: 0 }}>
                      <label className="form-label">Nome da Noiva <span className="required">*</span></label>
                      <input name="nomeNoiva" value={form.nomeNoiva} onChange={handleChange}
                        className={`form-input${errors.nomeNoiva ? ' error' : ''}`} />
                      {errors.nomeNoiva && <p className="form-error">{errors.nomeNoiva}</p>}
                    </div>
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 'var(--space-md)', marginBottom: 'var(--space-lg)' }}>
                    <div className="form-group" style={{ margin: 0 }}>
                      <label className="form-label">Telefone / WhatsApp <span className="required">*</span></label>
                      <input name="telefoneCasamento" value={form.telefoneCasamento} onChange={handleChange}
                        placeholder="(85) 99000-0000"
                        className={`form-input${errors.telefoneCasamento ? ' error' : ''}`} />
                      {errors.telefoneCasamento && <p className="form-error">{errors.telefoneCasamento}</p>}
                    </div>
                    <div className="form-group" style={{ margin: 0 }}>
                      <label className="form-label">Data do Casamento <span className="required">*</span></label>
                      <input type="date" name="dataCasamento" value={form.dataCasamento} onChange={handleChange}
                        className={`form-input${errors.dataCasamento ? ' error' : ''}`} />
                      {errors.dataCasamento && <p className="form-error">{errors.dataCasamento}</p>}
                    </div>
                    <div className="form-group" style={{ margin: 0 }}>
                      <label className="form-label">Local do Casamento <span className="required">*</span></label>
                      <input name="localCasamento" value={form.localCasamento} onChange={handleChange}
                        placeholder="Ex: Paróquia N. Sra. da Conceição"
                        className={`form-input${errors.localCasamento ? ' error' : ''}`} />
                      {errors.localCasamento && <p className="form-error">{errors.localCasamento}</p>}
                    </div>
                  </div>

                  <div className="submit-row" style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: 'var(--space-lg)', borderTop: '1px solid var(--gray-200)', marginTop: 'var(--space-lg)' }}>
                    <button type="submit" className="btn btn-primary btn-lg" disabled={loading}>
                      {loading ? 'Enviando...' : '💒 Enviar Solicitação'}
                    </button>
                  </div>
                </form>
              )}
            </div>
          )}
        </div>
      </section>
    </main>
  );
};

export default Solicitacoes;